// Function to apply filter to Energy Emissions

import { IEnergyEmission } from '../../../../../../../../../../hooks/api/energy-emissions';

// Based on the viewed based on selected Reference Period year and product's country
// This function should be called after energy emissions are fetched from API simply because FE is responsible for filtering, not BE
export const filterEnergyEmissions = (
  energyEmissions?: IEnergyEmission[],
  selectedReferencePeriodYear?: number,
  productCountryCode?: string,
): IEnergyEmission[] => {
  if (energyEmissions?.length) {
    let _filteredEmissions = energyEmissions;
    // Filter by the selected reference period. If user didn't select a reference period, all years are included
    if (selectedReferencePeriodYear) {
      // Before applying the year filter, check if the selected referencePeriod actually exists in the fetched emissions and of the same country (if product has a country).
      // If there is no such year in the list, then filter is not applied. This is to prevent filtering out all emissions by accident.
      const availableYears = new Set(
        energyEmissions
          .filter((item) => {
            if (productCountryCode) {
              // Filter by country if product has a country
              return item?.countryCode === productCountryCode;
            } else {
              // Otherwise, i.e. product has no country but region, do not filter by country
              return true;
            }
          })
          .map((item) => {
            return item?.year;
          })
          .filter((year) => {
            return !!year;
          }),
      );

      // If selected referencePeriod exists in availableYears
      if (availableYears.has(selectedReferencePeriodYear)) {
        _filteredEmissions = _filteredEmissions.filter((item) => {
          // If the emission has a year, check if it is matching the selected reference period year
          if (item?.year) {
            return item.year === selectedReferencePeriodYear;
          }

          // If the emission has no year, it is not filtered
          return true;
        });
      }
    }

    // Filter by product's country. If product has no country but region, then filter is not applied
    if (productCountryCode) {
      _filteredEmissions = _filteredEmissions.filter((item) => {
        // If the emission has a country code, check if it is matching the product's country code
        if (item.countryCode) {
          return item?.countryCode === productCountryCode;
        }

        // If emission has no country code, it is not filtered
        return true;
      });
    }

    return _filteredEmissions;
  }

  return [];
};
